import {motion} from "motion/react";
import {LogIn} from "lucide-react";
import logoDark from "../../assets/images/logo-dark.png";
import { useLanguage } from "../../i18n/LanguageContext";
import { translations } from "../../i18n/translations";

export function Navigation() {
  const { language, setLanguage } = useLanguage();
  const t = translations[language].nav;

  return (
    <nav
      className="nav-glass sticky top-0 z-50 w-full"
      style={{
        borderBottom: "1px solid var(--border)",
        backgroundColor: "rgba(10, 10, 11, 0.80)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <img
          src={logoDark}
          alt="Assistly"
          className="h-8 sm:h-12 cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        />

        <div className="flex items-center gap-4">
          <div
            className="flex items-center gap-1.5 text-xs"
            style={{ fontFamily: "var(--font-mono)", letterSpacing: "0.08em" }}
          >
            <button
              onClick={() => setLanguage("pl")}
              style={{
                color: language === "pl" ? "var(--gold)" : "var(--foreground-muted)",
                fontWeight: language === "pl" ? 600 : 400,
                transition: "color 0.2s",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "2px 0",
              }}
            >
              PL
            </button>
            <span style={{ color: "var(--border-strong)" }}>|</span>
            <button
              onClick={() => setLanguage("en")}
              style={{
                color: language === "en" ? "var(--gold)" : "var(--foreground-muted)",
                fontWeight: language === "en" ? 600 : 400,
                transition: "color 0.2s",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "2px 0",
              }}
            >
              EN
            </button>
          </div>

          <motion.a
            href="https://panel.assistly.tools"
            target="_blank"
            rel="noopener noreferrer"
            className="relative px-3 py-1.5 sm:px-5 sm:py-2 text-xs sm:text-sm rounded-lg flex items-center gap-1.5 sm:gap-2 overflow-hidden"
            style={{
              border: "1px solid var(--border-strong)",
              color: "var(--gold)",
              fontFamily: "var(--font-body)",
              fontWeight: 500,
            }}
            whileHover={{scale: 1.02}}
            whileTap={{scale: 0.98}}
          >
            <motion.span
              className="absolute inset-0 rounded-lg"
              style={{background: "var(--glow-gold)"}}
              initial={{opacity: 0}}
              whileHover={{opacity: 1}}
              transition={{duration: 0.2}}
            />
            <span className="relative flex items-center gap-2">
              <LogIn className="w-4 h-4" strokeWidth={1.5}/>
              {t.login}
            </span>
          </motion.a>
        </div>
      </div>
    </nav>
  );
}
